import * as React from "react";
const SvgFiRrRouter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-router_svg__a)">
      <path
        fill="#062147"
        d="M20 15h-4v-4a1 1 0 1 0-2 0v4H4c-2.206 0-4 1.794-4 4v1c0 2.206 1.794 4 4 4h16c2.206 0 4-1.794 4-4v-1c0-2.206-1.794-4-4-4m2 5c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2v-1c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2zM15 5c1.817 0 3.526.708 4.812 1.993a.999.999 0 1 1-1.414 1.414A4.77 4.77 0 0 0 15.001 7c-1.283 0-2.49.5-3.397 1.407a.999.999 0 1 1-1.414-1.414A6.76 6.76 0 0 1 15.001 5zM6 19.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 6 19.5m4 0a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 10 19.5M6.222 3.818A12.05 12.05 0 0 1 15 0c3.316 0 6.516 1.392 8.778 3.818a1 1 0 0 1-1.463 1.365A10.04 10.04 0 0 0 15 2.001c-2.763 0-5.43 1.16-7.315 3.182a1.001 1.001 0 0 1-1.463-1.365"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-router_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRouter;
